<template>
  <a-spin :spinning="saveLoading">
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">

        <a-form layout="vertical"  :form="form" >
          <a-form-item
            label="单位名称"
          >
            <a-input placeholder="名称"  readonly v-model="formData.name" />
          </a-form-item>
          <a-form-item
            label="描述"
          >
            <a-textarea rows="4" v-model="formData.desc" placeholder="描述"/>
          </a-form-item>

          <a-form-item
                  label="LOGO"
                  extra="显示在列表页,推荐尺寸750x750,推荐格式jpg"
          >
            <pic-uploader
                    :file-list="formData.pic"
            />
          </a-form-item>

          <a-form-item
                  label="联系电话"
                  hasFeedback
          >
            <a-input v-model="formData.phone"
                     placeholder="请输入联系电话"/>
          </a-form-item>

          <a-form-item
                  label="地址"
                  hasFeedback
          >
            <a-input v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入单位地址' }]}
        ]"
                     placeholder="请输入单位地址"/>
          </a-form-item>


          <a-form-item
                  label="微信号"
          >
            <a-input placeholder="微信号"  v-model="formData.order_add_friend_code" />
          </a-form-item>





          <a-form-item>
            <a-button type="primary"  :loading="saveLoading" @click="submitForm">保存</a-button>
          </a-form-item>
        </a-form>

      </a-col>
      <a-col :md="24" v-if="false" :lg="8" :style="{ minHeight: '180px' }">
        <div class="ant-upload-preview" @click="$refs.modal.edit(1)" >
          <a-icon type="cloud-upload-o" class="upload-icon"/>
          <div class="mask">
            <a-icon type="plus" />
          </div>
          <img :src="option.img"/>
        </div>
      </a-col>
    </a-row>

  </div>
    </a-spin>
</template>

<script>

  import { wyhSetting,getWyhSetting } from '@/api/wyh'
  import setting from '@/config/setting'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  export default {
    components: {
      PicUploader,
      RSwitch
    },
    data () {
      return {
        // cropper
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        saveLoading:false,
        form: this.$form.createForm(this),
        preview: {},
        option: {
          img: '/avatar2.jpg',
          info: true,
          size: 1,
          outputType: 'jpeg',
          canScale: false,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 180,
          autoCropHeight: 180,
          fixedBox: true,
          // 开启宽度和高度比例
          fixed: true,
          fixedNumber: [1, 1]
        },
        formData:{
          name:'江苏省啦啦操省市',
          desc:'江苏省啦啦操省市简介。。。',
          pic:[],
          phone:'18888888888',
          site_pic:[],
          site_url:'',
          pics:[],
          open_order_add_friend:2,
          order_add_friend_code:'',
          order_add_friend_pic:[],
          order_add_friend_text:'',
        }
      }
    },
    mounted(){
      let that = this;
      that.fetch();
    },
    methods: {

      fetch(){
        let that = this;
        getWyhSetting({
        }) .then(res => {
          that.formData = res.data;
          that.form.setFieldsValue({...res.data});
        }).catch(err =>{
        })

      },
      onMouseover(){
        console.log(1111)
      },
      onMouseleave(){
        console.log(2222)
      },
      submitForm(e){
        let self = this
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            self.saveLoading = true;
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
          wyhSetting(Object.assign(self.formData,values)).then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            console.log(err);
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
      opacity: 0;
      position: absolute;
      background: rgba(0,0,0,0.4);
      cursor: pointer;
      transition: opacity 0.4s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
